/**
 * @fileoverview Constantes relacionadas aos tipos de cliente
 * @description Este arquivo centraliza todas as constantes relacionadas aos tipos de cliente
 * para manter consistência e facilitar manutenção
 */

/**
 * @constant TYPE_CLIENT
 * @description Tipos de cliente disponíveis no sistema
 * @type {Array<{label: string, value: string}>}
 */
export const TYPE_CLIENT = [
  {
    label: "Agência",
    value: "Agencia",
  },
  {
    label: "Anunciante",
    value: "Anunciante",
  },
  {
    label: "Broker",
    value: "Broker",
  },
  {
    label: "Locatário",
    value: "Locatario",
  },
  {
    label: "Fornecedor",
    value: "Fornecedor",
  },
];

/**
 * @constant TYPE_PERSON
 * @description Tipos de pessoa disponíveis no sistema
 * @type {Array<{label: string, value: string}>}
 */
export const TYPE_PERSON = [
  {
    label: "Pessoa Física",
    value: "Pessoa Física",
  },
  {
    label: "Pessoa Jurídica",
    value: "Pessoa Jurídica",
  },
  {
    label: "Estrangeiro",
    value: "Estrangeiro",
  },
];

/**
 * @constant BRAZILIAN_STATES
 * @description Estados brasileiros para seleção
 * @type {Array<{label: string, value: string}>}
 */
export const BRAZILIAN_STATES = [
  { label: "AC", value: "AC" },
  { label: "AL", value: "AL" },
  { label: "AP", value: "AP" },
  { label: "AM", value: "AM" },
  { label: "BA", value: "BA" },
  { label: "CE", value: "CE" },
  { label: "DF", value: "DF" },
  { label: "ES", value: "ES" },
  { label: "GO", value: "GO" },
  { label: "MA", value: "MA" },
  { label: "MT", value: "MT" },
  { label: "MS", value: "MS" },
  { label: "MG", value: "MG" },
  { label: "PA", value: "PA" },
  { label: "PB", value: "PB" },
  { label: "PR", value: "PR" },
  { label: "PE", value: "PE" },
  { label: "PI", value: "PI" },
  { label: "RJ", value: "RJ" },
  { label: "RN", value: "RN" },
  { label: "RS", value: "RS" },
  { label: "RO", value: "RO" },
  { label: "RR", value: "RR" },
  { label: "SC", value: "SC" },
  { label: "SP", value: "SP" },
  { label: "SE", value: "SE" },
  { label: "TO", value: "TO" },
];

/**
 * @constant COUNTRIES
 * @description Países disponíveis para seleção
 * @type {Array<{label: string, value: string}>}
 */
export const COUNTRIES = [
  {
    label: "Brasil",
    value: "Brasil",
  },
];
